import React, { type FC } from 'react';
import { useWiredComponents } from '../../context/TopProps';
import { type WiredTextButtonProps } from './types';

type Props = WiredTextButtonProps & {
  // custom props will be applied only if wired component is not available
  customElClassName?: string;
};

export const TextButton: FC<Props> = ({ children, customElClassName, ...props }) => {
  const WiredComponents = useWiredComponents();

  if (WiredComponents?.TextButton) {
    return <WiredComponents.TextButton {...props}>{children}</WiredComponents.TextButton>;
  }

  return (
    <button className={customElClassName} {...props}>
      {children}
    </button>
  );
};
